module.exports = __webpack_public_path__ + "606c4a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LegalGroup/logo_ministerio_justicia.png
// module id = 1052
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13